import { Badge } from "~/components/ui/badge";
import { ShareLevel } from "~/services/projects";

const ACCESS_LEVEL_LABEL: Record<ShareLevel, string> = {
  [ShareLevel.OWNER]: "Owner",
  [ShareLevel.USER]: "User",
};

interface ProjectAccessBadgeProps {
  accessLevel: ShareLevel | null;
}

export function ProjectAccessBadge({ accessLevel }: ProjectAccessBadgeProps) {
  if (!accessLevel) {
    return null;
  }

  return (
    <Badge variant="outline" className="rounded-full">
      {ACCESS_LEVEL_LABEL[accessLevel]}
    </Badge>
  );
}
